export default __webpack_public_path__ + "static/jr-7c3630a2efab2ea9ee07fe51d8499ae9.png";